import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/CongratulationsModal.css';

export default function CongratulationsModal({ isOpen, onClose }) {
  // Hooks は常に最上部で
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="congratulations-modal">
        <div className="confetti-background" aria-hidden>
          <div className="confetti confetti-1"></div>
          <div className="confetti confetti-2"></div>
          <div className="confetti confetti-3"></div>
          <div className="confetti confetti-4"></div>
          <div className="confetti confetti-5"></div>
          <div className="confetti confetti-6"></div>
          <div className="confetti confetti-7"></div>
          <div className="confetti confetti-8"></div>
        </div>

        <div className="congratulations-content">
          <h1 className="congratulations-title">
            {t('congrats.title', 'Congratulations')}
          </h1>

          <div className="congratulations-message">
            <p>{t('congrats.msg1', 'おめでとうございます！')}</p>
            <p>{t('congrats.msg2', '全てのスタンプを取得しました。')}</p>
          </div>

          <button className="congratulations-button" onClick={onClose}>
            {t('quiz.backToMap', 'MAPに戻る')}
          </button>
        </div>
      </div>
    </div>
  );
}
